module.exports = __webpack_public_path__ + "static/media/1.288a7fcd.svg";